<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
 data(){
  return{

  }
 },
 created() {
    function calcFontSize() {
      const zoom =  document.body.clientWidth / 1539;
      // console.log('zoom'+zoom+"wide:"+ document.body.clientWidth)
      const size = zoom * 18;
      document.documentElement.style.fontSize = size + 'px';
      // console.log('设置字体大小', size);
    }
    window.onload = () => {
      calcFontSize();
      // console.log("页面加载完成")
      let resize_timer = null;
      const resize = () => {
        if (resize_timer) {
          clearTimeout(resize_timer);
        }
        resize_timer = setTimeout(() => {
          resize_timer = null;
          calcFontSize();
        }, 100);
      }
      window.onresize = resize;
    }
  },

}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
html,body,h3 {
  margin: 0;
  padding: 0}

  .el-main{
  /* background-color: #F5F6FB; */
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/App.vue